export function isDate(value) {
    return value instanceof Date;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ag-grid-enterprise/charts/dist/es6/chartAdaptor/chartComp/typeChecker.js
// module id = null
// module chunks = 